import type { FieldConfig, UseOptionsQuery, ValueState } from '../../types'

import { Operators } from '../../constants'
import { isObject, stringToArray } from '../../utils/utils'
import FieldController from '../Controller'

type Options = any[]

export default class SelectController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.useSelectOptions = config.useSelectOptions || this.useSelectOptions
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.getFilterTypes = config.getFilterTypes || this.getFilterTypes
	}

	onMenuScrollToBottom?: () => void

	onMenuScrollToTop?: () => void

	useSelectOptions(): UseOptionsQuery<Options> {
		return {
			data: [],
		}
	}

	hasValue = ({ value }: ValueState) =>
		Array.isArray(value) ? value.length > 0 : isObject(value)

	getInitialValue = () => ({
		operation: Operators.IS,
		value: '',
	})
	formatState = ({ value, operation }: ValueState, options?: Options) => {
		const _value = stringToArray(value || '')
		const selectedOptions = _value?.map(
			(value) =>
				options?.find((o) => value === o.value) || { value, label: value }
		)

		return {
			operation,
			value: selectedOptions.map((o) => o.label).join(', '),
		}
	}
	formatLabel = ({ value }: ValueState) => {
		if (Array.isArray(value) && value.length > 0)
			return `${this.label} (${value.length})`

		return this.label
	}
}
